module.exports = __webpack_public_path__ + "img/chevron-up.3a493887.svg";